import { useCallback } from 'react'
import translations, { DEFAULT_LANGUAGE, type Language, type TranslationKey } from './translations'

/**
 * 43OS jest jednojęzyczny (PL). Rozwiązujemy klucze zawsze po polsku —
 * także wtedy, gdy w localStorage/API została stara wartość 'de'/'en'.
 */
export function useTranslation() {
  const t = useCallback(
    // Przyjmujemy TranslationKey (z autouzupełnianiem) LUB dowolny string —
    // wiele miejsc woła t() z kluczem liczonym dynamicznie (np. t(LABEL_KEYS[id])).
    // Resolver ma bezpieczny fallback (brak klucza → zwraca goły string).
    (key: TranslationKey | (string & {})): string => {
      const entry = translations[key as TranslationKey]
      if (!entry) return key
      return entry.pl || key
    },
    [],
  )

  return { t, language: DEFAULT_LANGUAGE as Language }
}

/** Wersja bez hooka — do użycia poza komponentami Reacta. */
export function translate(key: TranslationKey | (string & {}), _lang?: Language): string {
  const entry = translations[key as TranslationKey]
  if (!entry) return key
  return entry.pl || key
}
